// biome-ignore lint/correctness/noUnusedImports: existing error
import React from 'react';
import {Input} from '~library/atoms/Input';
import {Typography} from '~library/atoms/Typography';

export const GuestOptionToggle = ({
  heading,
  description,
  checked,
  onChange,
  dataQaId,
  disabled = false,
  footerContent = <></>,
}) => (
  <>
    <div className="edit-flow__guest-options__option">
      <div className="edit-flow__guest-options__title">
        <Typography variant="paragraph2" color={disabled ? 'coin' : 'charcoal'}>
          {heading}
        </Typography>
        <Typography variant="paragraph3" color={disabled ? 'coin' : 'pebble'}>
          {description}
        </Typography>
      </div>
      <Input
        type="toggle"
        checked={checked}
        onChange={onChange}
        data-qa-id={dataQaId}
        disabled={disabled}
      />
    </div>
    {footerContent && checked && footerContent}
  </>
);
